module.exports = __webpack_public_path__ + "static/media/RenovaTuVestidor-full.2d1e6bdf.png";